/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import { useTranslation } from 'react-i18next';

import SummaryCard from '../../common/SummaryCard/SummaryCard';
import { actionTypes } from '../../common/SummaryCard/CardContext';

const useStyles = makeStyles(() => {
  return {
    cardMaxWidth: {
      maxWidth: 'unset',
    },
  };
});

export default function BioCard({ bioEntries, isSummary, readOnly = false, submission, onSectionChange, cardTitle }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <SummaryCard
      Icon={FingerprintIcon}
      cardTitle={cardTitle ?? t('seqlBio.title')}
      subheader=""
      entries={bioEntries}
      sectionName="submission_seqlBio"
      actionType={isSummary ? null : actionTypes.SUMMARY}
      isSummary={isSummary}
      readOnly={readOnly}
      className={classes}
      submission={submission}
      onSectionChange={onSectionChange}
    />
  );
}
